import React from 'react';
import Lock from '@mui/icons-material/Lock';

import { Typo } from 'uikit/content';

import AppHeader from './appHeader';

import styles from '../styles/noAccess.module.scss';

const NoAccess = ({
  hasBreadcrumbs, breadcrumbs, title, body,
}) => (
  <div className={styles.element}>
    <div className={styles.crumbs}>
      {(hasBreadcrumbs) && (
        <AppHeader
          hasBreadcrumbs
          breadcrumbs={breadcrumbs}
        />
      )}
    </div>
    <div className={styles.content}>
      <div>
        <Lock className={styles.icon} sx={{ height: 45, width: 45 }} />
      </div>
      <div className={styles.text}>
        <Typo
          className={styles.title}
          element="h1"
          title={title}
          variant="d05"
          weight="medium"
        >
          {title}
        </Typo>
        <Typo
          element="span"
          title={body}
          variant="b02"
        >
          {body}
        </Typo>
      </div>
    </div>
  </div>
);

export default React.memo(NoAccess);
